import React, {Suspense, lazy} from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Template from './Components/Template';
import {routes} from './router/routes';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './Components/Loader';

const Login = lazy(() => import('./Pages/Login'));
const ProcessesCreate = lazy(() => import('./Pages/Processes/Create'));
const ProcessesList = lazy(() => import('./Pages/Processes/List'));
const AccountList = lazy(() => import('./Pages/Accounts/List'));
const AccountCreate = lazy(() => import('./Pages/Accounts/Сreate'));
const AccountEdit = lazy(() => import('./Pages/Accounts/Edit'));
const AccountShow = lazy(() => import('./Pages/Accounts/Show'));
const BrokerList = lazy(() => import('./Pages/Brokers/List'));
const CreateBroker = lazy(() => import('./Pages/Brokers/Create'));
const Algorithms = lazy(() => import('./Pages/Algorithms'));
const PairsList = lazy(() => import('./Pages/Pairs/List'));
const PairsCreate = lazy(() => import('./Pages/Pairs/Create'));
const PairsEdit = lazy(() => import('./Pages/Pairs/Edit'));
const PairsShow = lazy(() => import('./Pages/Pairs/Show'));
const BalanceCurrencyList = lazy(() => import('./Pages/BalanceCurrency/List'));
const BalanceCurrencyCreate = lazy(() => import('./Pages/BalanceCurrency/Create'));
const AccountOrders = lazy(() => import('./Components/Orders'));
const ReportsList = lazy(() => import('./Pages/Reports/List'));
const ReportTemplates = lazy(() => import('./Pages/Reports/Templates'));
const ReportTemplateCreate = lazy(() => import('./Pages/Reports/CreateReportTemplate'));
const EditReportTemplate = lazy(() => import('./Pages/Reports/EditReportTemplates'));
const Settings = lazy(() => import('./Pages/Settings'));
const RolesAccessList = lazy(() => import('./Pages/RolesAccess/List'));
const RolesAccessEdit = lazy(() => import('./Pages/RolesAccess/Edit'));
const UsersList = lazy(() => import('./Pages/Users/List'));
const UserCreate = lazy(() => import('./Pages/Users/Create'));
const UserEdit = lazy(() => import('./Pages/Users/Edit'));
const UserShow = lazy(() => import('./Pages/Users/Show'));
const ClientsList = lazy(() => import('./Pages/Clients/List'));
const ClientsCreate = lazy(() => import('./Pages/Clients/Create'));
const ClientsShow = lazy(() => import('./Pages/Clients/Show'));
const ClientsEdit = lazy(() => import('./Pages/Clients/Edit'));
const DashboardList = lazy(() => import('./Pages/Dashboard/List'));
const PositionList = lazy(() => import('./Pages/Position/PositionList'));
const AlgorithmList = lazy(() => import('./Pages/Algorithm/AlgorithmList'));
import Risk from './Pages/Risk/List';
import LogsList from './Pages/Logs/List';

export default function App() {
	return (
		<Router>
			<Suspense fallback={<Loader/>}>
				<div>
					<Switch>
						<Route path={routes.LOGIN} exact={true} component={(props) => <Login {...props}/>}/>
						<Route path={routes.PAIR_LIST} exact={true}
							   component={(props) => <Template {...props}><PairsList {...props}/></Template>}/>
						<Route path={routes.PAIR_CREATE} exact={true}
							   component={(props) => <Template {...props}><PairsCreate {...props}/></Template>}/>
						<Route path={routes.PAIR_EDIT} exact={true}
							   component={(props) => <Template {...props}><PairsEdit {...props}/></Template>}/>
						<Route path={routes.PAIR_SHOW} exact={true}
							   component={(props) => <Template {...props}><PairsShow {...props}/></Template>}/>
						<Route path={routes.PROCESSES_CREATE}
							   component={(props) => <Template {...props}><ProcessesCreate {...props}/></Template>}/>
						<Route path={routes.PROCESSES} exact={true}
							   component={(props) => <Template {...props}><ProcessesList {...props}/></Template>}/>
						<Route path={routes.REPORTS} exact={true}
							   component={(props) => <Template {...props}><ReportsList {...props}/></Template>}/>
						<Route path={routes.REPORTS_TEMPLATES} exact={true}
							   component={(props) => <Template {...props}><ReportTemplates {...props}/></Template>}/>
						<Route path={routes.REPORTS_TEMPLATES_CREATE} exact={true}
							   component={(props) =>
								   <Template {...props}><ReportTemplateCreate {...props}/></Template>}/>
						<Route path={routes.REPORTS_TEMPLATES_EDIT} exact={true}
							   component={(props) => <Template {...props}><EditReportTemplate {...props}/></Template>}/>
						<Route path={routes.ACCOUNTS_CREATE} exact={true}
							   component={(props) => <Template {...props}><AccountCreate {...props}/></Template>}/>
						<Route path={routes.ACCOUNTS_ORDERS} exact={true}
							   component={(props) => <Template {...props}><AccountOrders {...props}/></Template>}/>
						<Route path={routes.ACCOUNTS_SHOW} exact={true}
							   component={(props) => <Template {...props}><AccountShow {...props}/></Template>}/>
						<Route path={routes.ACCOUNTS_EDIT} exact={true}
							   component={(props) => <Template {...props}><AccountEdit {...props}/></Template>}/>
						<Route path={routes.ACCOUNTS} exact={true}
							   component={(props) => <Template {...props}><AccountList {...props}/></Template>}/>
						<Route path={routes.BROKER_CREATE} exact={true}
							   component={(props) => <Template {...props}><CreateBroker {...props}/></Template>}/>
						<Route path={routes.BROKER_LIST} exact={true}
							   component={(props) => <Template {...props}><BrokerList {...props}/></Template>}/>
						<Route path={routes.ALGORITHM} exact={true}
							   component={(props) => <Template {...props}><Algorithms {...props}/></Template>}/>
						<Route path={routes.ALGORITHM_CREATE} exact={true}
							   component={(props) => <Template {...props}><Algorithms {...props}/></Template>}/>
						<Route path={routes.ALGORITHM_EDIT} exact={true}
							   component={(props) => <Template {...props}><Algorithms {...props}/></Template>}/>
						<Route path={routes.ALGORITHM_SHOW} exact={true}
							   component={(props) => <Template {...props}><Algorithms {...props}/></Template>}/>
						<Route path={routes.BALANCE_CURRENCY_CREATE} exact={true}
							   component={(props) => <Template {...props}><BalanceCurrencyCreate {...props}/></Template>}/>
						<Route path={routes.BALANCE_CURRENCY_LIST} exact={true}
							   component={(props) => <Template {...props}><BalanceCurrencyList {...props}/></Template>}/>
						<Route path={routes.USER_LIST} exact={true}
							   component={(props) => <Template {...props}><UsersList {...props}/></Template>}/>
						<Route path={routes.USER_CREATE} exact={true}
							   component={(props) => <Template {...props}><UserCreate {...props}/></Template>}/>
						<Route path={routes.USER_EDIT} exact={true}
							   component={(props) => <Template {...props}><UserEdit {...props}/></Template>}/>
						<Route path={routes.USER_SHOW} exact={true}
							   component={(props) => <Template {...props}><UserShow {...props}/></Template>}/>
						<Route path={routes.SETTINGS} exact={true}
							   component={(props) => <Template {...props}><Settings {...props}/></Template>}/>
						<Route path={routes.CLIENTS} exact={true}
							   component={(props) => <Template {...props}><ClientsList {...props}/></Template>}/>
						<Route path={routes.CLIENTS_CREATE} exact={true}
							   component={(props) => <Template {...props}><ClientsCreate {...props}/></Template>}/>
						<Route path={routes.CLIENTS_SHOW} exact={true}
							   component={(props) => <Template {...props}><ClientsShow {...props}/></Template>}/>
						<Route path={routes.CLIENTS_EDIT} exact={true}
							   component={(props) => <Template {...props}><ClientsEdit {...props}/></Template>}/>
						<Route path={routes.ROLES_ACCESS} exact={true}
							   component={(props) => <Template {...props}><RolesAccessList {...props}/></Template>}/>
						<Route path={routes.ROLES_ACCESS_EDIT} exact={true}
							   component={(props) => <Template {...props}><RolesAccessEdit {...props}/></Template>}/>
						<Route path={routes.DASHBOARD_LIST} exact={true}
							   component={(props) => <Template {...props}><DashboardList {...props}/></Template>}/>
						<Route path={routes.POSITION_LIST} exact={true}
						   component={(props) => <Template {...props}><PositionList {...props}/></Template>}/>
						   <Route path={routes.ALGORITHM_LIST} exact={true}
						   component={(props) => <Template {...props}><AlgorithmList {...props}/></Template>}/>
						<Route path={routes.RISK} exact={true}
						   component={(props) => <Template {...props}><Risk {...props}/></Template>}/>
						   <Route path={routes.LOGS} exact={true}
						   component={(props) => <Template {...props}><LogsList {...props}/></Template>}/>
					</Switch>
					<ToastContainer/>
				</div>
			</Suspense>
		</Router>
	);
}

